import { createPlayTransport } from "./play-transport";
import { createPlayLeagueReads } from "./play-league-reads";
import { createPlayPlayerReads } from "./play-player-reads";
import { createPlayEpisodeReads } from "./play-episode-reads";
export type { DivisionLeaderboardRead } from "./play-league-reads";
export function createPlayApi({
  signal,
}: { signal?: AbortSignal | undefined } = {}) {
  const transport = createPlayTransport({ signal });
  const { playFetch, get } = transport;
  return {
    playFetch,
    get,
    ...createPlayLeagueReads(transport),
    ...createPlayPlayerReads(transport),
    ...createPlayEpisodeReads(transport),
  };
}
export type PlayApi = ReturnType<typeof createPlayApi>;
